import fesRequest from './fesRequest'
import { history } from 'services/routing'
import { pathMod } from 'config'
import { axios } from '.'

export const getCmsContent = (versionNumber, brandId, languageId) => {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: `/content-integration/${versionNumber}/${brandId}/${languageId}`,
    }).then(
      result => {
        resolve(result)
      },
      err => {
        // eslint-disable-next-line no-console
        console.error(err)
        history.push(`${pathMod()}/error`)
      }
    )
  })
}
